import { defineStore } from 'pinia';

const useRouteManagerStore = defineStore('routeManager', {
  state: () => ({
    sourceName: '',
  }),
  getters: {
    getSourceName: state => state.sourceName,
  },
  actions: {
    setSourceName(source: string) {
      this.$patch((state) => {
        state.sourceName = source;
      });
    },
  },
});

export default useRouteManagerStore;
